<template>
	<div>
		<div v-show="isPc == true" class="index warp">
			<div class="index_funcArea">
				<div class="news">
					<div class="news_header">
						<p
							v-for="(item, index) in tabarlist"
							:key="index"
							:class="index == tabarlistCur ? 'news_header_title' : 'news_header_title_no'"
							@click="tabarchange(index)"
						>
							{{ item }}
						</p>
						<div v-if="flag_list" class="news_header_more bluefont">
							<p></p>
							<router-link :to="'/' + flag_list[tabarlistCur]['p_flag'] + '?id=' + flag_list[tabarlistCur]['p_id'] + '&name=' + flag_list[tabarlistCur]['p_name']">
								<p class="bluefont">更多>></p>
							</router-link>
						</div>
					</div>
					<div v-if="swiperList" class="news_content">
						<div class="news_swiper">
							<div class="swiper-container">
								<div class="swiper-wrapper">
									<van-swipe :autoplay="3000" :show-indicators="false">
										<van-swipe-item v-for="(item, index) in swiperList.slice(0,5)" :key="index">
											<img :src="item.coverimage" v-lazy="image"/>
											<div class="news_swiper_title">
												<p>{{ item.title }}</p>
											</div>
										</van-swipe-item>
									</van-swipe>
								</div>
							</div>
						</div>
						<div class="news_list">
							<div v-if="Topping" class="news_list_topping">
								<div class="news_list_topping_title bluefont">{{ Topping.title }}</div>
								<div class="news_list_topping_text lightgrayfont">{{ Topping.introduction }}</div>
							</div>
							<ul v-if="latest_announcement" class="news_list_list" style="flex: auto">
								<li @click="getpage('新闻动态', item.id)" v-show="index < 5" v-for="(item, index) in latest_announcement" :key="index">
									<img src="../static/imgs/yiyuan-2.png" />
									<p>{{ item.title }}</p>
									<span>[{{ item.createtime }}]</span>
								</li>
							</ul>
						</div>
					</div>
					<div v-else style="height: 400px"></div>
				</div>

				<div class="index_bulletin" style="min-height: 500px">
					<div class="index_bulletin_explore">
						<div v-if="name_list" class="plate_title">
							<p>{{ name_list[0]['nickname'] }}</p>
							<router-link :to="'/' + name_list[0]['p_flag'] + '?id=' + name_list[0]['p_id'] + '&name=' + name_list[0]['p_name']">
								<p class="bluefont" style="font-size: 12px">更多>></p>
							</router-link>
						</div>
						<ul class="plate_list">
							<li @click="getpage('科学教研', item.id)" v-show="index < 4" v-for="(item, index) in scientific_research_work" :key="index">
								<img src="../static/imgs/多边形 2.png" alt="" />
								<p class="overomit">{{ item.title }}</p>
							</li>
						</ul>
					</div>
					<div class="index_bulletin_tenders">
						<div v-if="name_list" class="plate_title">
							<p>{{ name_list[1]['nickname'] }}</p>
							<router-link :to="'/' + name_list[1]['p_flag'] + '?id=' + name_list[1]['p_id'] + '&name=' + name_list[1]['p_name']">
								<p class="bluefont" style="font-size: 12px">更多>></p>
							</router-link>
						</div>
						<ul class="plate_list">
							<li @click="getpage('招标工作', item.id)" v-show="index < 4" v-for="(item, index) in tender_announcement" :key="index">
								<img src="../static/imgs/多边形 2.png" alt="" />
								<p class="overomit">{{ item.title }}</p>
							</li>
						</ul>
					</div>
					<div class="index_bulletin_teams">
						<div v-if="name_list" class="plate_title">
							<p>{{ name_list[2]['nickname'] }}</p>
							<!-- <p class="bluefont" @click="godoctorTeam()" style="font-size: 12px">更多>></p> -->
							<router-link :to="'/' + name_list[2]['p_flag'] + '?id=' + name_list[2]['p_id'] + '&name=' + name_list[2]['p_name']">
								<p class="bluefont" style="font-size: 12px">更多>></p>
							</router-link>
						</div>
						<div style="width: 460px;height: 445px;background-color: #F7FCFF">
							<van-swipe :autoplay="3000" :show-indicators="false">
								<van-swipe-item  v-for="(item, index) in doctor_team" :key="index">
									<ul class="index_bulletin_teams_person">
										<li v-for="(items, indexs) in item" :key="indexs" @click="getpage('医生团队', items.id)">
											<div><img :src="items.coverimage" alt="" /></div>
											<p>{{ items.fullname }}</p>
										</li>
									</ul>
								</van-swipe-item>
							</van-swipe>
						</div>
					</div>
				</div>

				<HospitalGUI></HospitalGUI>
			</div>
		</div>

		<!-- 移动端 -->
		<div v-show="isPc == false" class="index-mob">
			<div class="mob-tabar">
				<ul class="warp-mob">
					<li
						:style="tabarlistCur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
						@click="tabarchange(index)"
						v-for="(item, index) in tabarlist"
						:key="index"
					>
						{{ item }}
					</li>
					<p class="bluefont" style="height: 0.5rem; line-height: 0.5rem; margin-right: 0.2rem" @click="gomanageHospital()">更多 ></p>
				</ul>
			</div>

			<div v-if="swiperList[0]" class="index-mob_news warp-mob">
				<div class="index-mob_swiper">
					<van-swipe class="my-swipe" :autoplay="3000">
						<van-swipe-item v-for="(item, index) in swiperList" :key="index" style="position: relative">
							<img :src="item.coverimage" />
							<!-- <div style="position: absolute; bottom: 0; left: 0; width: 100%">
								<p style="position: absolute; bottom: 0; line-height: 20px; font-size: 12px; width: 100%; text-align: left; background-color: #86add6">
									{{ item.title }}
								</p>
							</div> -->
						</van-swipe-item>
					</van-swipe>
				</div>

				<div class="index-mob_news_newscont warp-mob">
					<div v-if="Topping" class="index-mob_news_newscont_title bluefont">
						<h1>{{ Topping.title }}</h1>
					</div>
				<!-- 	<div v-if="Topping" class="index-mob_news_newscont_cont">
						<p>{{ Topping.introduction }}</p>
					</div> -->
					<ul v-if="latest_announcement" class="index-mob_news_newscont_list">
						<li @click="getpage('工作动态', item.id)" v-show="index < 5" v-for="(item, index) in latest_announcement" :key="index">
							<div>
								<img src="../static/imgs/yiyuan-2.png" />
								<h1 class="overomit">{{ item.title }}</h1>
								<p>></p>
							</div>
							<span>{{ item.createtime }}</span>
						</li>
					</ul>
				</div>
			</div>

			<div class="index_team-mob">
				<div v-if="name_list" class="index-mob_titleline">
					<h1>{{ name_list[2]['nickname'] }}</h1>
					<!-- <p class="bluefont">更多 ></p> -->
					<p class="bluefont">
						<router-link :to="'/' + name_list[2]['p_flag'] + '?id=' + name_list[2]['p_id'] + '&name=' + name_list[2]['p_name']">更多 ></router-link>
					</p>
				</div>
				<div class="index_team-mob_list">
					<div style="line-height: 50px;margin-top: 14px;">
						<van-swipe :autoplay="3000" :show-indicators="false">
							<van-swipe-item  v-for="(doctor_teams, index) in doctor_team" :key="index">
								<ul class="warp-mob" style="align-items: center;">
									<li @click="getpage('医生团队', item.id)" v-for="(item, indexs) in doctor_teams" :key="indexs">
										<div><img style="width: 100%;height:100%;" :src="item.coverimage" alt="" /></div>
										<p>{{ item.fullname }}</p>
									</li>
								</ul>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>

			<div class="index-mob-work">
				<div v-if="name_list" class="index-mob_titleline">
					<h1>{{ name_list[0]['nickname'] }}</h1>
					<!-- <p class="bluefont">更多 ></p> -->
					<p class="bluefont">
						<router-link :to="'/' + name_list[0]['p_flag'] + '?id=' + name_list[0]['p_id'] + '&name=' + name_list[0]['p_name']">更多 ></router-link>
					</p>
				</div>
				<ul class="warp-mob">
					<li @click="getpage('科研工作', item.id)" v-show="index < 4" v-for="(item, index) in scientific_research_work" :key="index">
						<img src="../static/imgs/多边形 2.png" alt="" />
						<p class="overomit">{{ item.title }}</p>
						<span>></span>
					</li>
				</ul>
			</div>

			<div class="index-mob-work">
				<div v-if="name_list" class="index-mob_titleline">
					<h1>{{ name_list[1]['nickname'] }}</h1>
					<!-- <p class="bluefont">更多 ></p> -->
					<p class="bluefont">
						<router-link :to="'/' + name_list[1]['p_flag'] + '?id=' + name_list[1]['p_id'] + '&name=' + name_list[1]['p_name']">更多 ></router-link>
					</p>
				</div>
				<ul class="warp-mob">
					<li @click="getpage('招标公告', item.id)" v-show="index < 4" v-for="(item, index) in tender_announcement" :key="index">
						<img src="../static/imgs/多边形 2.png" alt="" />
						<p class="overomit">{{ item.title }}</p>
						<span>></span>
					</li>
				</ul>
			</div>

			<div class="footnav-mob">
				<ul class="warp-mob">
					<li>
						医院文化
						<span>></span>
					</li>
					<li>
						职工天地
						<span>></span>
					</li>
					<li>
						医疗保险
						<span>></span>
					</li>
					<li>
						药事管理
						<span>></span>
					</li>
					<li>
						医院感染管理
						<span>></span>
					</li>
					<li>
						信息公开
						<span>></span>
					</li>
					<li>
						投诉电话
						<span>></span>
					</li>
				</ul>
			</div>

			<div class="foot-mob"></div>
		</div>
		
	</div>
</template>

<script>
import HospitalGUI from '../components/HospitalGUI.vue';
export default {
	name: 'WebLijinhospitalIndex',
	components: {
		HospitalGUI
	},
	data() {
		return {
			isPc: true,
			current: 0,
			swiperOption1: '',
			breadcrumb: ['首页', '下一级', '下一级', '下一级', '下一级'],
			Topping: null,
			latest_announcement: null,
			scientific_research_work: null,
			tender_announcement: null,
			doctor_team: null,
			swiperList: [],
			tabarlist: null,
			tabar_id_list: null,
			tabarlistCur: 0,
			data1: null,
			flag_list: null,
			name_list: null
		};
	},

	mounted() {

		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata();
	},

	methods: {
		onChange(index){
			this.current = index;
		},
		get(item, index) {
			console.log(item, index);
		},
		godoctorTeam() {
			this.$router.push('/doctorTeam');
		},
		tabarchange(index) {
			this.tabarlistCur = index;
			this.step3();
		},

		// 内容页
		getpage(e, id) {
			this.$router.push({
				path: '/content',
				query: { title: e, id: id }
			});
		},
		gomanageHospital() {
			let url =
				'/' + this.flag_list[this.tabarlistCur]['p_flag'] + '?id=' + this.flag_list[this.tabarlistCur]['p_id'] + '&name=' + this.flag_list[this.tabarlistCur]['p_name'];
			this.$router.push(url);
		},
		step1() {
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/getsetting'
			})
				.then((response) => {
					//请求成功
					console.log('getsetting', response.data);
					this.step2(response.data);
				})
				.catch((error) => {
					//请求失败
					console.log('getsetting', error);
				});
		},
		step2(datas) {
			// 获取内容
			this.tabar_id_list = [datas.data['index_correlation1'], datas.data['index_correlation2']];
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					getname: this.tabar_id_list
				}
			})
				.then((getname) => {
					//请求成功
					console.log('index_correlation', getname.data);
					this.tabarlist = [];
					this.flag_list = getname.data.data;
					for (var i = 0; i < getname.data.data.length; i++) {
						this.tabarlist[i] = getname.data.data[i]['nickname'];
					}
					// 块1
					this.step3();
					// 块234
					this.step4(datas.data);
				})
				.catch((error) => {
					//请求失败
					console.log('index_correlation1', error);
				});
		},
		step3() {
			// 详情
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					category_id: this.tabar_id_list[this.tabarlistCur]
				}
			})
				.then((response) => {
					//请求成功
					console.log('category_id', response.data);
					if (response.data.data.list) {
						let arr = response.data.data.list;
						this.swiperList = arr.filter(item => item.flg == 1)
						console.log("newArr:"+this.swiperList);
					} else {
						this.swiperList = [];
					}
					this.Topping = response.data.data.list[0];
					this.latest_announcement = response.data.data.list;
				})
				.catch((error) => {
					//请求失败
					console.log('category_id', error);
				});
		},
		step4(datas) {
			let id_list = [datas['index_correlation3'], datas['index_correlation4'], datas['index_correlation5']];
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					getname: id_list
				}
			})
				.then((getname) => {
					//请求成功
					console.log('step4', getname.data);
					this.name_list = getname.data.data;
				})
				.catch((error) => {
					//请求失败
					console.log('index_correlation1', error);
				});
			// scientific_research_work 科研工作
			// datas['index_correlation3']
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					category_id: datas['index_correlation3'],
					num: 5
				}
			})
				.then((response) => {
					//请求成功
					console.log('scientific_research_work', response.data);
					this.scientific_research_work = response.data.data.list;
				})
				.catch((error) => {
					//请求失败
					console.log('scientific_research_work', error);
				});
			// tender_announcement 招标公告
			// datas['index_correlation4']
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					category_id: datas['index_correlation4'],
					num: 5
				}
			})
				.then((response) => {
					//请求成功
					console.log('tender_announcement', response.data);
					this.tender_announcement = response.data.data.list;
				})
				.catch((error) => {
					//请求失败
					console.log('tender_announcement', error);
				});
			// doctor_team 医生团队
			// datas['index_correlation5']
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article_shouye',
				params: {
					category_id: datas['index_correlation5']
				}
			})
				.then((response) => {
					//请求成功
					console.log('doctor_team', response.data);
					this.doctor_team = response.data.data.list;
				})
				.catch((error) => {
					//请求失败
					console.log('doctor_team', error);
				});
		},
		getdata() {
			// 内容
			this.step1();
		}
	}
};
</script>

<style scoped>
@import url('../static/css/style.css');
.news_swiper_title{
	position:absolute;
	bottom: 0;
}
.index_funcArea {
	width: 100%;
	height: 100%;
	position: relative;
}
.my-swipe .van-swipe-item {
	color: #fff;
	font-size: 20px;
	line-height: 150px;
	text-align: center;
	background-color: #39a9ed;
}
.news_header_title_no {
	width: 90px;
	height: 100%;
	border-radius: 5px;
	color: #000;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
}
</style>
